<div class="quill-material-container" #container>
  <div class="editor" (click)="onTouched()"></div>
</div>
